import { createSlice } from '@reduxjs/toolkit';
import {
  getUsersList,
  addUser,
  deleteUser,
  updateUser,
  getUserById,
} from './usersThunk';
import { toast } from 'react-toastify';

const reduxState = { data: [], status: "loading", error: null };
const initialState = {
  usersList: reduxState,
  newUser: reduxState,
  updateUser: reduxState,
  deletedUser: reduxState,
  oneUser: reduxState,
};

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    resetUserState: (state) => {
      state.newUser = reduxState;
      state.updateUser = reduxState;
      state.deletedUser = reduxState;
      state.oneUser = reduxState;
    },
  },
  extraReducers: (builder) => {
    builder
      // all users
      .addCase(getUsersList.pending, (state) => {
        return {
          ...state,
          usersList: { ...state.usersList, status: 'loading' },
        };
      })
      .addCase(getUsersList.fulfilled, (state, action) => {
        return {
          ...state,
          usersList: {
            ...state.usersList,
            status: 'succeeded',
            data: action.payload,
          },
        };
      })
      .addCase(getUsersList.rejected, (state, action) => {
        return {
          ...state,
          usersList: {
            ...state.usersList,
            status: 'failed',
            error: action.error.message,
          },
        };
      })
      // add user
      .addCase(addUser.pending, (state) => {
        return { ...state, newUser: { ...state.newUser, status: 'loading' } };
      })
      .addCase(addUser.fulfilled, (state, action) => {
        toast.success('Utilisateur ajouté avec succès');
        return {
          ...state,
          newUser: {
            ...state.newUser,
            status: 'succeeded',
            data: action.payload,
          },
        };
      })
      .addCase(addUser.rejected, (state, action) => {
        toast.error("Erreur lors de l'ajout de l'utilisateur");
        return {
          ...state,
          newUser: {
            ...state.newUser,
            status: 'failed',
            error: action.error.message,
          },
        };
      })
      // update user
      .addCase(updateUser.pending, (state) => {
        return {
          ...state,
          updateUser: { ...state.updateUser, status: 'loading' },
        };
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        toast.success('Utilisateur mis à jour avec succès');
        return {
          ...state,
          updateUser: {
            ...state.updateUser,
            status: 'succeeded',
            data: action.payload,
          },
        };
      })
      .addCase(updateUser.rejected, (state, action) => {
        toast.error("Erreur lors de la mise à jour de l'utilisateur");
        return {
          ...state,
          updateUser: {
            ...state.updateUser,
            status: 'failed',
            error: action.error.message,
          },
        };
      })
      // get user by id
      .addCase(getUserById.pending, (state) => {
        return { ...state, oneUser: { ...state.oneUser, status: 'loading' } };
      })
      .addCase(getUserById.fulfilled, (state, action) => {
        return {
          ...state,
          oneUser: {
            ...state.oneUser,
            status: 'succeeded',
            data: action.payload,
          },
        };
      })
      .addCase(getUserById.rejected, (state, action) => {
        return {
          ...state,
          oneUser: {
            ...state.oneUser,
            status: 'failed',
            error: action.error.message,
          },
        };
      })
      // delete user
      .addCase(deleteUser.pending, (state) => {
        return {
          ...state,
          deletedUser: { ...state.deletedUser, status: 'loading' },
        };
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        toast.success("L'utilisateur est supprimer avec succés!");
        return {
          ...state,
          deletedUser: {
            ...state.deletedUser,
            status: 'succeeded',
            data: action.payload,
          },
        };
      })
      .addCase(deleteUser.rejected, (state, action) => {
        toast.error("Erreur lors de la suppression de l'utilisateur");
        return {
          ...state,
          deletedUser: {
            ...state.deletedUser,
            status: 'failed',
            error: action.error.message,
          },
        };
      });
  },
});

export const { resetUserState } = usersSlice.actions;

export default usersSlice.reducer;
